import React, { useState, useEffect } from 'react';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.min.css';

const App = () => {
  const [data, setData] = useState([]);
  const initialFilters = {
    company: '',
    location: '',
    dateFrom: '',
    dateTo: '',
    accuracyMin: ''
  };
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    const fetchData = async () => {
      const query = new URLSearchParams(filters).toString();
      const response = await fetch(`http://3.95.214.169:5000/contracts?${query}`);
      const json = await response.json();
      setData(json.map(item => ({
        company: item.company,
        location: item.location,
        federalAgency: item.federal_agency,
        date: new Date(item.date).toLocaleDateString(),
        amountValue: `${item.amount_value.toLocaleString()}`, 
        contractType: item.contract_type,
        purpose: item.purpose,
        completionDate: item.completion_date ? new Date(item.completion_date).toLocaleDateString() : '',
        contractNumber: item.contract_number,
        url: item.url,
        accuracy: `${(item.accuracy * 100).toFixed(1)}%` 
      })));
    };

    fetchData();
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
    // console.log(filters)
  };

  const clearFilters = () => {
    setFilters(initialFilters);
  };

  return (
    <div>
      <div style={{ background: 'black', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px' }}>
        <h1>Defense Insight</h1>
        <nav>
          {/* <a href="/" style={{ color: 'white', marginRight: '20px', textDecoration: 'none' }}>Home</a> */}
        </nav>
      </div>
      <div style={{ padding: '20px', background: '#f2f2f2', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Company"
          name="company"
          value={filters.company}
          onChange={handleInputChange}
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <input
          type="text"
          placeholder="Location"
          name="location"
          value={filters.location}
          onChange={handleInputChange}
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <input
          type="date"
          placeholder="Date From"
          name="dateFrom"
          value={filters.dateFrom}
          onChange={handleInputChange}
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <input
          type="date"
          placeholder="Date To"
          name="dateTo"
          value={filters.dateTo}
          onChange={handleInputChange}
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <input
          type="number"
          placeholder="Min Accuracy (%)"
          name="accuracyMin"
          value={filters.accuracyMin}
          onChange={handleInputChange}
          style={{ padding: '8px', marginRight: '10px' }}
        />
        <button onClick={clearFilters} style={{ padding: '8px 16px' }}>Clear Filters</button>
      </div>
      <div style={{ height: '600px', overflow: 'auto' }}>
        <HotTable
          data={data}
          colHeaders={[
            'Company', 'Location', 'Federal Agency', 'Date', 'Amount Value',
            'Contract Type', 'Purpose', 'Completion Date', 'Contract Number', 'URL', 'Accuracy'
          ]}
          columns={[
            { data: 'company' },
            { data: 'location' },
            { data: 'federalAgency' },
            { data: 'date' },
            { data: 'amountValue' },
            { data: 'contractType' },
            { data: 'purpose' },
            { data: 'completionDate' },
            { data: 'contractNumber' },
            { data: 'url' },
            { data: 'accuracy' }
          ]}
          colWidths={[200, 200, 200, 120, 150, 200, 300, 120, 150, 200, 100]}
          rowHeaders={true}
          width="100%"
          height="550px"
          columnSorting={true}
          contextMenu={true}
          manualRowResize={true}
          manualColumnResize={true}
          licenseKey="non-commercial-and-evaluation"
        />
      </div>
    </div>
  );
};

export default App;